import { Payments } from '@or-sdk/payments';
import _ from 'lodash';
import config from '../config';
import store from '../vuex/store';
export default new Payments({
    paymentsUrl: config.PAYMENTS_API_URL,
    token: () => _.get(store, 'state.auth.token'),
});
